import { colors } from './colors';

const PAPER = '#1e1d2c';

// Experimental Telma dark theme; grey scale is inverted so grey900 stays the highest-contrast text
export const darkColors = {
    ...colors,

    // paper & background
    paper: PAPER,

    // surface layers
    canvas: '#15141f',
    surface: PAPER,
    surfaceSubtle: '#252436',
    surfaceBorder: 'rgba(196, 194, 255, 0.10)',
    sidebar: '#2b2a44',

    // primary
    primaryUltraLight: '#232234',
    primaryLight: '#2e2d48',
    primaryMain: '#a3a2e3',
    primaryDark: '#c4c3f0',
    primary200: '#8281ca',
    primary800: '#b8b7ec',

    // secondary
    secondaryBgPinkHover: '#3a2b3e',
    secondaryBgPink: '#33283a',
    secondaryBgPinkDark: '#2c2333',
    secondaryLight: '#2d2645',
    secondaryMain: '#b39cf8',
    secondaryDark: '#f0a19b',
    secondary200: '#9d7ff5',
    secondary800: '#fabbb7',

    // bot card tints
    botCardSurface: '#211f30',
    botCardSurfaceHover: '#28253a',
    botCardBorder: '#352f45',
    botCardPink: '#3a2733',
    botCardRose: '#3a2638',
    botCardLilac: '#2f2a48',
    botCardViolet: '#2d2650',
    botCardAccent: '#b39cf8',
    botCardPinkDark: '#e08a9b',

    // grey
    grey50: '#232233',
    grey100: '#2a2939',
    grey200: '#353446',
    grey300: '#4a4960',
    grey500: '#9a99b0',
    grey600: '#b4b3c8',
    grey700: '#d4d3e3',
    grey900: '#f1f0f8',
};
